import React, { useMemo } from 'react';

const COLORS = ['#d97757', '#5a8268', '#f59e0b', '#0e3a3a', '#e879a6', '#60a5fa'];

export const Confetti = ({ count = 60 }) => {
  const pieces = useMemo(() => Array.from({ length: count }, (_, i) => ({
    id: `piece-${i}`,
    left: Math.random() * 100,
    delay: Math.random() * 2.5,
    duration: 2.8 + Math.random() * 2,
    size: 6 + Math.random() * 6,
    color: COLORS[i % COLORS.length],
    rotate: Math.random() * 360,
    round: Math.random() > 0.5,
  })), [count]);

  return (
    <div className="pointer-events-none fixed inset-0 z-[9990] overflow-hidden" data-testid="confetti-overlay" aria-hidden="true">
      <style>{`@keyframes fdn-confetti-fall{0%{transform:translateY(-6vh) rotate(0deg);opacity:1}90%{opacity:1}100%{transform:translateY(105vh) rotate(720deg);opacity:0}}`}</style>
      {pieces.map((p) => (
        <span
          key={p.id}
          style={{
            position: 'absolute',
            top: 0,
            left: `${p.left}%`,
            width: p.size,
            height: p.size * (p.round ? 1 : 0.45),
            background: p.color,
            borderRadius: p.round ? '50%' : '2px',
            transform: `rotate(${p.rotate}deg)`,
            animation: `fdn-confetti-fall ${p.duration}s linear ${p.delay}s 2 both`,
          }}
        />
      ))}
    </div>
  );
};
